import { Component, OnInit, ViewChild } from '@angular/core';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { filter, first, map } from 'rxjs/operators';
import { stringToJson, replaceBetween } from '../helpers/functions';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FaildDialogComponent } from '../faild-dialog/faild-dialog.component'
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  providers: [{
    provide: STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
  }]
})
export class PaymentComponent implements OnInit {
  @ViewChild('stepper',{static:false}) stepper: MatStepper;
  title = 'sadan-web-payment';
  currentLanguage: string = 'ar';
  href = new URL(window.location.href);
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  paymentMethods = [];
  cartData = [];
  deviceId;
  userId;
  token;
  mosqueId;
  graveId;
  myPlaceId;
  placeType;
  details;
  paymentId;
  locale = "ar";
  platform = "m";
  cartTotal: any = 0;
  cartCurrent:any = 0;
  paymentComplete: boolean = false
  placeDetails = {
    name_ar:"",
    name_en:"",
  };
  fees:number = 0;
  selectedStep = 0;
  trackId = 0;
  loading = true;
  paymentSuccess = true;
  deliveryTime;

  constructor(private _formBuilder: FormBuilder,
              private route:ActivatedRoute,
              private router: Router,
              private http: HttpClient,
              private translate: TranslateService,
              public dialog: MatDialog,
              private platformData: Platform,) 
{ 
    this.translate.onLangChange.subscribe(data => {
      if (data.lang == 'ar') {
        this.currentLanguage = 'ar';
      } else {
        this.currentLanguage = 'en';
      }
    })
}

  async ngOnInit() {
    if(this.platformData.ANDROID || this.platformData.IOS || this.platformData.WEBKIT) {
      this.platform = "m";
    }else{
      this.platform = "p";
    }
    /*const prevUrl = document.referrer;
    const fetchedUrl = prevUrl ? new URL(prevUrl) : null;
    if(prevUrl && fetchedUrl){
      if(fetchedUrl.host == environment.configs.host) this.platform = "p";
    }*/
    try{
      this.deviceId = this.route.snapshot.paramMap.get('deviceId');
      this.userId = this.route.snapshot.paramMap.get('userId');
      this.token = this.route.snapshot.paramMap.get('token');
      this.mosqueId = this.route.snapshot.paramMap.get('mosqueId');
      this.graveId = this.route.snapshot.paramMap.get('graveId');
      this.myPlaceId = this.route.snapshot.paramMap.get('myPlaceId');
      this.placeType = this.route.snapshot.paramMap.get('placeType');
      this.details = this.route.snapshot.paramMap.get('details');
      this.locale = this.route.snapshot.paramMap.get('locale');
      this.paymentId = this.route.snapshot.queryParamMap.get("paymentId");
      if(this.locale) this.useLanguage(this.locale);
      /*alert(`
      deviceId : ${this.deviceId}
      userId : ${this.userId}
      token : ${this.token}
      mosqueId : ${this.mosqueId}
      graveId : ${this.graveId}
      myPlaceId : ${this.myPlaceId}
      placeType : ${this.placeType}
      details : ${this.details}
      paymentId : ${this.paymentId}
      `)*/
      if(!this.checkPlaceType()) return this.errorDialog();
      this.firstFormGroup = this._formBuilder.group({
        firstCtrl: [null, [Validators.required]],
        userPhone: [null, [Validators.required, Validators.pattern(/^[9654]\d{7}$/)],],
        reciverPhone: ["",],
        notes: ["",],
      });
      if(!this.paymentId){
        await this.getTotalInvoice();
        await this.getPaymentMethods(this.cartTotal);
        this.loading = false;
      }else{
        //now select last step and check payment status
        this.paymentComplete = true;
        setTimeout(() => {
          this.stepper.selectedIndex = 2;
        });
        //lets send paymentId to backend
        await this.http.get(environment.configs.sadanApi + `payment/success?paymentId=${this.paymentId}`).pipe(first()).toPromise();
        //now lets check payment data
        const data = {
          "Key": this.paymentId,
          "KeyType": "PaymentId"
        }
        //lets check if payment is success
        const checkPaymentSuccess = await this.http.post(environment.configs.crosApi+environment.configs.myFatoorahApi + "GetPaymentStatus",data,this.Headers()).pipe(first()).toPromise();
        console.log(JSON.parse(`${checkPaymentSuccess["IsSuccess"]}`),checkPaymentSuccess);
        if(checkPaymentSuccess["IsSuccess"]){
          console.log(checkPaymentSuccess["Data"]["UserDefinedField"]);
          console.log("success")
          this.paymentComplete = true;
          //now lets send donate to our db
          const donateData = {
            deviceId:this.deviceId,
            userId:this.userId == Number((stringToJson(checkPaymentSuccess["Data"]["UserDefinedField"])["userId"])) ? Number((stringToJson(checkPaymentSuccess["Data"]["UserDefinedField"])["userId"])):0,
            cost:Number(checkPaymentSuccess["Data"]["InvoiceValue"]),
            placeId:this.placeType.toLowerCase() == 'mosques' ? Number(this.mosqueId):0,
            graveId:this.placeType.toLowerCase() == 'graves' ? Number(this.graveId):0,
            myPlaceId:this.placeType.toLowerCase() == 'myplaces' ? Number(this.myPlaceId):0,
            placeType:this.placeType,
            paymentId:this.paymentId,
            details:this.details,
            reciverPhone:(stringToJson(checkPaymentSuccess["Data"]["UserDefinedField"])["reciverPhone"]).toString(),
            note:(stringToJson(checkPaymentSuccess["Data"]["UserDefinedField"])["notes"]).toString(),
            isQuickDonate: this.placeType.toLowerCase() == 'quickdonate' ? 1:0,
          }
          const sendDonate = await this.http.post(environment.configs.sadanApi + "donates",donateData).pipe(first()).toPromise();
          if(sendDonate){
            let placeType;
            if((this.placeType === 'mosques' && this.mosqueId != 1) || this.placeType === 'graves' || this.placeType === 'myPlaces' || this.placeType === 'quickDonate') placeType = 'placesDeliveryTime_';
            if(this.placeType === 'mosques' && this.mosqueId == 1) placeType = 'marketDeliveryTime_';
            const time = await this.http.get(environment.configs.sadanApi + "sadanInfo").pipe(first()).toPromise();
            if(time && time.hasOwnProperty(`${placeType}${this.translate.currentLang}`)){
              this.deliveryTime = time[`${placeType}${this.translate.currentLang}`];
            }
            this.trackId = sendDonate["id"];
            this.paymentSuccess = true;
          }
          this.loading = false;
        }else{
          this.paymentSuccess = false;
          this.loading = false;
          this.errorPaymentDialog();
        }
      }
    }catch(error){
      console.log(error.message)
      this.paymentSuccess = false;
      this.loading = false;
      this.errorDialog();
    }
  }

  ngAfterContentChecked() {
    if(this.paymentId && this.paymentComplete){
      this.selectedStep = 2;
    }
  }

  checkPlaceType(){
    if(this.placeType.toLowerCase() === "mosques" || this.placeType.toLowerCase() === "graves" || this.placeType.toLowerCase() === "myplaces" || this.placeType.toLowerCase() === "quickdonate"){
      return true;
    }else{
      return false;
    }
  }
  
  async getTotalInvoice(){
    //lets rest cartTotal as security
    this.cartTotal = 0;
    //rest fees to zero
    this.fees = 0;
    //define placeData to get data
    let placeData;
    //lets get fees from place type
    if(this.placeType.toLowerCase() == "mosques" && this.mosqueId != 1){
      placeData = await this.http.get(environment.configs.sadanApi + `places/${this.mosqueId}`).pipe(first()).toPromise();
      if(placeData) this.fees = placeData["deliveryFees"];
    }
    if(this.placeType.toLowerCase() == "mosques" && this.mosqueId == 1){
      placeData = await this.http.get(environment.configs.sadanApi + `baridInfo`).pipe(first()).toPromise();
      if(placeData) this.fees = placeData["baridFees"];
    }
    if(this.placeType.toLowerCase() == "graves"){
      placeData = await this.http.get(environment.configs.sadanApi + `graves/${this.graveId}`).pipe(first()).toPromise();
      if(placeData) this.fees = placeData["deliveryFees"];
    }
    if(this.placeType.toLowerCase() == "myplaces"){
      //lets get all myPlaces for current token
      placeData = await this.http.get(environment.configs.sadanApi + `my-places`,{
        headers:{
          'Authorization': 'Bearer ' + this.token,
          'Content-Type': 'application/json',
        }
      }).pipe(first()).toPromise();
      //if we found data
      if(placeData){
        //lets find current one by Id to get details
        const myPlaceInfo = placeData.find(data => data.id = this.myPlaceId);
        //after this lets get fees from area
        const areaData:any = await this.http.get(environment.configs.sadanApi + `zones/${myPlaceInfo["userArea"]}`).pipe(first()).toPromise();
        if(areaData) this.fees = areaData["myPlacesFees"];
      }
    }
    //lets get max and min boxes from place
    let placeMin = 0;
    let placeMax = 0;
    if(this.placeType.toLowerCase() == "mosques"){
      placeMin = placeData['placeBoxesMin'];
      placeMax = placeData['placeBoxesMax'];
    }
    if(this.placeType.toLowerCase() == "graves"){
      placeMin = placeData['graveBoxesMin'];
      placeMax = placeData['graveBoxesMax'];
    }
    //now lets get all sizes and calculate total
    for (let bottleDetails of stringToJson(this.details)){
      //send get request to get data
      const bottleData = await this.http.get(environment.configs.sadanApi + `bottleSizes/${bottleDetails.sizeId}`).pipe(first()).toPromise();
      //if size already exist lets plus it in total and put it in sizes info
      if(bottleData) {
        if(bottleData["isPallet"] == 0 && bottleDetails.qty < placeMin && ((this.placeType.toLowerCase() == "mosques" && this.mosqueId != 1) || this.placeType.toLowerCase() == "graves")){
          alert("الكمية المطلوبة اقل من الحد الادني")
        }else if(bottleData["isPallet"] == 0 && bottleDetails.qty > 200 && ((this.placeType.toLowerCase() == "mosques" && this.mosqueId != 1) || this.placeType.toLowerCase() == "graves")){
          alert("الكمية المطلوبة اكثر من الحد الأقصي")
        }else{
          this.cartTotal += Number(Number(bottleData["sizePrice"]) * Number(bottleDetails.qty));
          this.cartData.push({
            itemName: bottleData["sizeTitle_ar"],
            itemPrice: bottleData["sizePrice"],
            quantity: bottleDetails.qty
          });
        }
      }
    }
    //now we have fees lets calculate new total
    this.cartTotal = Number(this.cartTotal);
    this.cartCurrent = this.cartTotal;
    this.cartTotal += Number(this.fees);
  }

  async getPaymentMethods(totalPayment){
    const data = {
      "InvoiceAmount": totalPayment,
      "CurrencyIso": "KWD"
    }
    const methodsData = await this.http.post(environment.configs.crosApi+environment.configs.myFatoorahApi + "InitiatePayment",data,this.Headers()).pipe(first()).toPromise();
    if(methodsData.hasOwnProperty("Data")){
      if(methodsData["Data"].hasOwnProperty("PaymentMethods")){
        this.paymentMethods = methodsData["Data"]["PaymentMethods"].filter(data => data.PaymentMethodId == 1 || data.PaymentMethodId == 2);
      }
    }
  }

  Headers(){
    return  {
      headers:{
        'Authorization': 'Bearer ' + environment.configs.myFatoorahToken,
        'Content-Type': 'application/json',
      },
    }
  }

  goToApp(){
    if(this.platform == "m"){
      window.open("sadanappkwt://sadankwt.com/");
    }else{
      const url = environment.configs.appHost;//this.href.protocol + "//" + this.href.host + '/home/';
      window.location.href = url;
    }
    //window.location.href = 'sadanappkwt://sadankwt.com/';
  }

  // if user completed payment method skip step 2 and go to step 3 (completed)
  async checkPayment(stepper: MatStepper) {
    //console.log(this.firstFormGroup.value)
    try{
      let userName = "فاعل خير";
      let userPhone = null;
      let userEmail = null;
      let userInfo;
      if(this.userId != 0){
        userInfo = await this.http.get(environment.configs.sadanApi + "users/me",{
          headers:{
            'Authorization': 'Bearer ' + this.token,
            'Content-Type': 'application/json',
          }
        })
        .pipe(first())
        .toPromise();
        userName = userInfo.username;
        //userPhone = userInfo.phone.replaceAt("+965", "");
        if(userInfo.phone.substr(0, 4) == "+965"){
          userPhone = replaceBetween(userInfo.phone,0, 4,"");
        }else if(userInfo.phone.substr(0, 5) == "00965"){
          userPhone = replaceBetween(userInfo.phone,0, 5,"");
        }else{
          userPhone = userInfo.phone;
        }
        userEmail = userInfo.email;
      }
      const formData = this.firstFormGroup.value;
      const mathodId = formData.firstCtrl;
      const cartData = {
        "PaymentMethodId": mathodId,
        "CustomerName": userName,
        "DisplayCurrencyIso": "KWD",
        "MobileCountryCode": "+965",
        "CustomerMobile": userPhone,
        "CustomerEmail": userEmail,
        "InvoiceValue": this.cartTotal.toFixed(2),
        "CallBackUrl": `${environment.configs.paymentCallBack}${this.deviceId}/${this.userId}/0/${this.mosqueId}/${this.graveId}/${this.myPlaceId}/${this.placeType}/${encodeURIComponent(this.details)}/${this.locale}/`,
        "ErrorUrl": `${environment.configs.paymentCallBack}${this.deviceId}/${this.userId}/0/${this.mosqueId}/${this.graveId}/${this.myPlaceId}/${this.placeType}/${encodeURIComponent(this.details)}/${this.locale}/`,
        "Language": "AR",
        "UserDefinedField": `{"userId":"${this.userId != 0 ? this.userId:this.deviceId}","reciverPhone":"${formData.reciverPhone}","notes":"${formData.notes}","userPhone":"${formData.userPhone}"}`,
        "InvoiceItems": []
      }
      this.cartData.forEach(data => {
        cartData["InvoiceItems"].push({
          ItemName: data["itemName"],
          Quantity: data["quantity"],
          UnitPrice: data["itemPrice"]
        })
      });
      if (this.fees != 0) {
        cartData["InvoiceItems"].push({
          ItemName: "delivery_fees",
          UnitPrice: this.fees,
          Quantity: 1
        });
      }
      //console.log(cartData)
      const methodsData = await this.http.post(environment.configs.crosApi+environment.configs.myFatoorahApi + "executePayment",cartData,this.Headers()).pipe(first()).toPromise();
      if(methodsData){
        if(methodsData.hasOwnProperty("Data")){
          if(methodsData["Data"].hasOwnProperty("PaymentURL")){
            //console.log((stringToJson(methodsData["Data"]["UserDefinedField"])["userId"]).toString())
            this.paymentComplete = true;
            setTimeout(() => {
              this.stepper.selectedIndex = 1;
            });
            const payUrl = methodsData["Data"]["PaymentURL"];
            window.location.href = payUrl;
          }
        }
      }
      //stepper.selectedIndex = 2//index - 1;
      //stepper.steps.last.select()
      //console.log()
    }catch(error){
      this.loading = false;
    /* alert("هناك خطأ") */
      const dialogRef = this.dialog.open(FaildDialogComponent, {
        width: '530px',
        data: { errorType: 'connection',platform:this.platform, }, //error type may ba payment or connection
        /* data: { errorType: 'connection' } */
      });
    }
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  errorDialog(){
    const dialogRef = this.dialog.open(FaildDialogComponent, {
      width: '530px',
      data: { errorType: 'connection',platform:this.platform, },
    });
  }

  errorPaymentDialog(){
    const dialogRef = this.dialog.open(FaildDialogComponent, {
      width: '530px',
      data: { errorType: 'payment',platform:this.platform, },
    });
  }
}
